var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"md-shared"},[_c('md-shared-header'),_c('main',{staticClass:"md-shared-main"},[_c('router-view')],1),_c('md-shared-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }